import FeedbackScreen from '@/screens/FeedbackScreen';
import { AdminRouteGate } from '@/components/route/RouteGate';

export default function FeedbackRoute() {
  return (
    <AdminRouteGate>
      <FeedbackScreen />
    </AdminRouteGate>
  );
}
